import React from 'react';
import type { FC, HTMLAttributes } from 'react';
import TopAppBar from '@pedidosya/web-fenix/system/TopAppBar';

interface NavBarProps extends HTMLAttributes<HTMLElement> {
  title: string;
  onBack(): void;
}

export const Navbar: FC<NavBarProps> = ({ title, onBack }) => {
  return <TopAppBar left="icon" middle="title" titleValue={title} onGoBack={onBack} />;
};
